/** Mirrors jriit-cms/src/lib/cyber-fee-structure.ts — used when API omits cyberSecurityFeeStructure (older CMS). */
export const DEFAULT_CYBER_FEE_STRUCTURE = {
  enabled: true,
  title: "Cybersecurity Program Fee Structure",
  columnHeaders: [
    "BASIC CERTIFICATE (NTA-4)",
    "DIPLOMA (NTA-5)",
    "DIPLOMA (NTA-6)",
  ],
  rows: [
    { sno: 1, particulars: "TUITION FEE", l4: 1260000, l5: 1130000, l6: 1260000 },
    { sno: 2, particulars: "EXAMINATION FEE", l4: 175000, l5: 175000, l6: 205000 },
    { sno: 3, particulars: "TOOL KIT", l4: 200000, l5: 200000, l6: null },
    { sno: 4, particulars: "STUDENT ID CARD", l4: 10000, l5: 10000, l6: 10000 },
    { sno: 5, particulars: "NACTVET QA", l4: 20000, l5: 20000, l6: 20000 },
    { sno: 6, particulars: "ACADEMIC ACTIVITY", l4: 60000, l5: 60000, l6: 60000 },
    { sno: 7, particulars: "CAUTION MONEY (NR)", l4: 50000, l5: null, l6: null },
    { sno: 8, particulars: "STUDENT UNION", l4: 5000, l5: 5000, l6: 5000 },
    { sno: 9, particulars: "REGISTRATION NACTVET", l4: 20000, l5: null, l6: null },
    { sno: 10, particulars: "CERTIFICATION A+ CORE 1&2", l4: null, l5: null, l6: null },
    { sno: 11, particulars: "CERTIFICATION N+", l4: null, l5: null, l6: null },
    { sno: 12, particulars: "CERTIFICATION SECURITY +", l4: null, l5: null, l6: 810000 },
    { sno: 13, particulars: "GRADUATION", l4: null, l5: null, l6: 40000 },
  ],
  totals: { l4: 1800000, l5: 1600000, l6: 1600000 },
  extras: [
    { label: "LAPTOP", amount: 700000 },
    { label: "APPLICATION FORM", amount: 20000 },
  ],
  footnote:
    "Totals shown are for the standard programme package. Certification Security+ (NTA-6) is listed separately from that total where applicable. All amounts in TZS.",
};
